import React from "react";
import styles from "../../../../styles/index";
import "./index.less";

import { IFeedDetailView } from "../../../../service/Index";

const PREFIX = "TopicFeed";

interface IProps {
  detail: IFeedDetailView;
}
interface IState {
  pic_url: string;
}

class ClubActivityTopicFeed extends React.Component<IProps, IState> {
  public state: IState = {
    pic_url: "",
  };

  componentWillMount() {
    this.setState({
      pic_url: this._getFeedPicUrl(),
    });
  }

  /**
   * 获取feed封面图片
   */
  _getFeedPicUrl = (): string => {
    const { detail } = this.props;
    if (detail.select_feed_pic_id) {
      const select_pic = detail.pics.find(
        (pic) => pic.pic_id == detail.select_feed_pic_id
      );
      return select_pic ? select_pic.url : "";
    } else {
      return detail.pics && detail.pics.length ? detail.pics[0].url : "";
    }
  };

  /**
   * 格式化日期格式
   */
  _formatTime = (timeStr: string): string => {
    const date = new Date(timeStr.replace(/-/g, "/"));
    return [date.getFullYear(), date.getMonth() + 1, date.getDate()]
      .map((item) => {
        return item < 10 ? `0${item}` : item;
      })
      .join(".");
  };

  render() {
    const { detail } = this.props;
    return (
      <a
        className={PREFIX}
        href={detail.codoon_url}
        style={styles.feedItem}
        target="_blank"
      >
        <div
          style={{
            ...styles.feedImg,
            backgroundImage: `url(${this.state.pic_url})`,
          }}
        />
        <p className={`${PREFIX}-content`}>{detail.content}</p>
        <div style={styles.feedUserWrapper} className="clearfix">
          <div style={styles.feedUser}>
            <img src={detail.portrait} style={styles.feedPortrait} />
            <span style={styles.feedNick}>{detail.nick}</span>
          </div>
          <div style={styles.feedTime}>
            {this._formatTime(detail.create_time)}
          </div>
        </div>
      </a>
    );
  }
}

export default ClubActivityTopicFeed;
